import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

/**
 * One route config for both /store/<slug>/order and /store/<slug>/order/<step>. As two configs
 * the route-reuse check (future.routeConfig === curr.routeConfig) would destroy and recreate the
 * stepper on every step change (the tags pager lesson) - and with it the hold countdown and the
 * route-scoped OrderFlowStore.
 */
export function storeOrderMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    if ((segments.length === 3 || segments.length === 4) && segments[0].path === 'store' && segments[2].path === 'order') {
        const posParams: { [name: string]: UrlSegment } = { slug: segments[1] };
        if (segments.length === 4) {
            posParams['step'] = segments[3];
        }
        return { consumed: segments, posParams };
    }
    return null;
}

/** registered by app-routing.module.ts next to the store + store/:slug routes */
export const STORE_ORDER_ROUTES: Routes = [
    {
        // a customer's read-only order page (the mail link)
        path: 'store/order/:token',
        loadComponent: () => import('./order-status.component').then((m) => m.OrderStatusComponent),
    },
    {
        matcher: storeOrderMatcher,
        loadComponent: () => import('./order-page.component').then((m) => m.OrderPageComponent),
    },
];
